import React, { Component } from "react";
import down from "../../../assets/icons/down.svg";
import "./Dropdown.scss";

export interface IProps {
    options: any;
    searchKey: string;
    placeholder?: string;
    noDataMsg?: string;
    isDownArrow?: boolean;
    id?: string;
    name?: string;
    disabled?: boolean;
    errorText?: string;
    autoComplete?: string;
    searchLength: number;
    className?: string;
    defaultValue?: string;
    required?: boolean;
    onChange?: (value: string) => void;
    onOptionSelect?: (value: any) => void;
    onBlur?: (value: any) => void;
    ariaLabel?: string;
    ariaLabelledBy?: string;
}

export interface IState {
    isShowSuggestions: boolean;
    value: string;
    selectedObj?: object | undefined;
    activeIndex: number;
}

class Dropdown extends Component<IProps, IState> {
    listboxId: string;

    constructor(props: any) {
        super(props);
        this.listboxId = `${props.name || "dropdown"}-listbox`;
        this.state = {
            isShowSuggestions: false,
            value: props.defaultValue || "",
            selectedObj: undefined,
            activeIndex: -1,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps: IProps, prevState: IState) {
        if (nextProps.defaultValue !== prevState.value && nextProps.defaultValue !== undefined) {
            this.setState({ value: nextProps.defaultValue });
        }
    }

    onFocus = () => {
        if (this.props.searchLength === 0 || this.state.value.length >= this.props.searchLength) {
            this.setState({ isShowSuggestions: true });
        } else {
            this.setState({ isShowSuggestions: false });
        }
    };

    onChange = (value: any) => {
        this.setState({ value: value, selectedObj: undefined });
        this.props.onChange && this.props.onChange(value);
    };

    onOptionSelect = (item: any) => {
        this.setState({ value: item[this.props.searchKey], selectedObj: item, isShowSuggestions: false, activeIndex: -1 });
        if (this.props.onOptionSelect) {
            this.props.onOptionSelect(item);
        }
    };
    handleBlur = () => {
        setTimeout(() => {
            if (this.state.isShowSuggestions) {
                this.setState({ isShowSuggestions: false, activeIndex: -1 });
            }
            this.props.onBlur && this.props.onBlur(this.state.selectedObj);
        }, 300);
    };

    handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const { options } = this.props;
        if (!options || !options.length) return;

        if (e.key === "ArrowDown") {
            e.preventDefault();
            this.setState((prev) => ({
                isShowSuggestions: true,
                activeIndex: Math.min(prev.activeIndex + 1, options.length - 1),
            }));
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            this.setState((prev) => ({
                activeIndex: Math.max(prev.activeIndex - 1, 0),
            }));
        } else if (e.key === "Enter" && this.state.isShowSuggestions && this.state.activeIndex >= 0) {
            e.preventDefault();
            this.onOptionSelect(options[this.state.activeIndex]);
        } else if (e.key === "Escape") {
            this.setState({ isShowSuggestions: false, activeIndex: -1 });
        }
    };

    render() {
        const { isShowSuggestions, activeIndex } = this.state;
        let ddCount = 0;
        const inputId = this.props.id || this.props.name;
        const errorId = inputId ? `${inputId}-error` : undefined;

        const noData = (
            <div className="dds_odiv" role="option" id={`${this.listboxId}-no-data`} aria-selected={false} aria-disabled="true">
                <div className="dds_oldiv">
                    <span className="dds_olabel">{this.props.noDataMsg}</span>
                </div>
            </div>
        );

        let showSuggestions = this.props.options.map((item: any, i: any) => {
            const dropdownData = item[this.props.searchKey];
            ddCount++;
            const isSelected = this.state.selectedObj === item;
            return (
                <div
                    key={i}
                    id={`${this.listboxId}-opt-${i}`}
                    className={"dds_odiv" + (activeIndex === i ? " dds_active" : "")}
                    role="option"
                    aria-selected={isSelected}
                    tabIndex={-1}
                    onClick={() => this.onOptionSelect(item)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            this.onOptionSelect(item);
                        }
                    }}
                >
                    <div className="dds_oldiv">
                        <span className="dd_lbl">
                            {isSelected ? <i className="edel-icon-tick" aria-hidden="true"></i> : <i aria-hidden="true"></i>}
                            <span className="dds_olabel" dangerouslySetInnerHTML={{ __html: dropdownData }}></span>
                        </span>
                    </div>
                </div>
            );
        });

        return (
            <div className={"dd_grp " + (isShowSuggestions ? "dd_open" : "")}>
                <input
                    name={this.props.name}
                    id={inputId}
                    type="text"
                    readOnly
                    role="combobox"
                    aria-expanded={isShowSuggestions}
                    aria-controls={this.listboxId}
                    aria-autocomplete="list"
                    aria-activedescendant={
                        isShowSuggestions && activeIndex >= 0
                            ? `${this.listboxId}-opt-${activeIndex}`
                            : undefined
                    }
                    aria-invalid={this.props.errorText ? true : undefined}
                    aria-describedby={this.props.errorText && errorId ? errorId : undefined}
                    aria-label={
                        this.props.ariaLabelledBy
                            ? undefined
                            : this.props.ariaLabel ||
                              (!inputId
                                ? this.props.placeholder || this.props.name || "Select"
                                : undefined)
                    }
                    aria-labelledby={this.props.ariaLabelledBy}
                    required={this.props.required || undefined}
                    aria-required={this.props.required ? true : undefined}
                    className={"dds " + this.props.className + (this.props.errorText ? " error" : "")}
                    onChange={(e) => this.onChange(e.target.value)}
                    onBlur={this.handleBlur}
                    onFocus={this.onFocus}
                    onKeyDown={this.handleKeyDown}
                    value={this.state.value}
                    disabled={this.props.disabled}
                    placeholder={this.props.placeholder}
                    autoComplete={this.props.autoComplete ? this.props.autoComplete : "off"}
                    style={this.props.isDownArrow ? { backgroundImage: `url(${down})` } : {}}
                />
                {isShowSuggestions && (showSuggestions || this.props.noDataMsg) ? (
                    <div className="option_grp" role="listbox" id={this.listboxId}>
                        {ddCount ? showSuggestions : noData}
                    </div>
                ) : null}
                {this.props.errorText && (
                    <p className="help_text red" id={errorId} role="alert" aria-live="assertive">
                        {this.props.errorText}
                    </p>
                )}
            </div>
        );
    }
}

export default Dropdown;
